import hotkeys from 'hotkeys-js'
import { navigateToUrl } from '../../common/helpers'
import { SHELL_SETTINGS_ROUTE } from '../../common/routes'

export const registerShellSettingsHotkeys = () => {
  hotkeys('ctrl+s', () => {
    navigateToUrl(SHELL_SETTINGS_ROUTE)
  })
}
